var _path;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgLogout(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, ["title", "titleId"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 21,
    height: 20,
    viewBox: "0 0 21 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M20.7232 10.2949L14.0562 16.9619C13.4609 17.5572 12.4291 17.1405 12.4291 16.2873V12.4776H7.03205C6.50424 12.4776 6.07962 12.0529 6.07962 11.5251V7.71541C6.07962 7.18761 6.50424 6.76299 7.03205 6.76299H12.4291V2.95327C12.4291 2.10402 13.457 1.68337 14.0562 2.27864L20.7232 8.94563C21.0923 9.31867 21.0923 9.92187 20.7232 10.2949ZM8.61943 16.7635V15.1761C8.61943 14.9142 8.40513 14.6999 8.14321 14.6999H4.80971C4.1073 14.6999 3.53981 14.1324 3.53981 13.43V5.81056C3.53981 5.10814 4.1073 4.54065 4.80971 4.54065H8.14321C8.40513 4.54065 8.61943 4.32636 8.61943 4.06444V2.47706C8.61943 2.21514 8.40513 2.00084 8.14321 2.00084H4.80971C2.70643 2.00084 1 3.70728 1 5.81056V13.43C1 15.5333 2.70643 17.2397 4.80971 17.2397H8.14321C8.40513 17.2397 8.61943 17.0254 8.61943 16.7635Z",
    fill: "black"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgLogout);
export default __webpack_public_path__ + "static/media/logout.9b41d725.svg";
export { ForwardRef as ReactComponent };